import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import PopModal from '../../../Constant/Custom/Models/PopModal';
import { serverUrl } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';

function Payment({ handlePrevious }) {

    const { auth } = useContext(AuthContext);

    const storedUser = auth.user;
    const [paymentFormHtml, setPaymentFormHtml] = useState('');
    const [community, setCommunity] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [csrfToken, setCsrfToken] = useState('');

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);


    const initiatePayment = async () => {
        try {
            const response = await axios.post(`${serverUrl}/api/initiate-payment`,
                { appno: storedUser?.appno,community },
                {
                    headers: {
                        'CSRF-Token': csrfToken  // Use CSRF token
                    },
                    withCredentials: true
                }
            );

            setPaymentFormHtml(response.data);
            setTimeout(() => {
                const form = document.getElementById('billdesk-form');
                if (form) {
                    form.submit(); // Trigger form submission
                }
            }, 100); // Slight delay to ensure the form is rendered
            // window.location.href = `https://www.paymentgateway.com?data=${formPayload}`;
        } catch (error) {
            console.error('Error initiating payment:', error);
        }
    };

    useEffect(() => {
        const fetchCsrfToken = async () => {
            localStorage.setItem('currentSection', 7);
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };
        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const retrieveCommunity = async () => {
            try {
                const response = await axios.post(`${serverUrl}/api/retrieve-community`, { appno: storedUser?.appno })
                if (response.status === 200) {
                    setCommunity(response.data.community);
                } else {
                    alert('Something went wrong. Please try again later')
                }
            } catch (error) {
                alert('Something went wrong. Please try again later')
            }
        }
        retrieveCommunity();
    }, [csrfToken])

    return (
        <div>
            <table className='payment-table'>
                <tr className='payment-table-row'>
                    <td><strong>Amount :</strong></td>
                    <td><strong>{(community === "SC" || community === "ST" || community === "SCA" )? `Rs. 250` : `Rs. 500`}</strong></td>
                </tr>
            </table>
            <div className='next-button'>
                <button className='log-btn button-secondary' onClick={handlePrevious}>Previous</button>
                <button className='log-btn button-primary' onClick={initiatePayment}>Proceed to Payment</button>
            </div>
            <h6 style={{ textAlign: 'center' }}><span style={{ fontSize: '20px' }}>*</span>{`Do not pay more than once, please verify your payment status before making another payment. You can verify the payment status from  -> Profile -> Transactions. By mistake if you made multiple payments, refund will not be entertained online, any multiple payment refunds will be processed only offline after counselling is completed. `}</h6>

            {/* This is where we inject the form */}
            {paymentFormHtml && (
                <div dangerouslySetInnerHTML={{ __html: paymentFormHtml }} />
            )}
        </div>
    )
}

export default Payment;